var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{ref:_vm.id,attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }